import React, { FunctionComponent, useContext } from 'react'
import Checkbox from '@material-ui/core/Checkbox'
import { makeStyles } from '@material-ui/core/styles'
import FormControlLabel from '@material-ui/core/FormControlLabel'

import '../styles/Filter.scss'
import { useFilter } from '../App'

interface CheckboxProps {
  color: string
  checked: boolean
  name?: string
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void
}

const ColoredCheckbox: FunctionComponent<CheckboxProps> = (props) => {
  const { color, checked, name, onChange } = props

  const useStyles = makeStyles({
    root: {
      color,
      padding: '0.5rem',
    },
  })

  const classes = useStyles(props)
  return (
    <Checkbox
      color='default'
      className={classes.root}
      onChange={onChange}
      name={name}
      checked={checked}
    />
  )
}

const Filter: FunctionComponent = () => {
  const { variable: filter, setVariable: setFilter } = useContext(useFilter)!

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setFilter({ ...filter, [e.target.name]: e.target.checked })
  }

  return (
    <div className='Filter'>
      <FormControlLabel
        control={
          <ColoredCheckbox
            color='#e67c73'
            name='calendar'
            onChange={(e) => handleChange(e)}
            checked={filter.calendar}
          />
        }
        label='Calendar'
      />
      <FormControlLabel
        control={
          <ColoredCheckbox
            color='#f5bf25'
            name='contacts'
            onChange={(e) => handleChange(e)}
            checked={filter.contacts}
          />
        }
        label='Contacts'
      />
      <FormControlLabel
        control={
          <ColoredCheckbox
            color='#32b579'
            name='dropbox'
            onChange={(e) => handleChange(e)}
            checked={filter.dropbox}
          />
        }
        label='Dropbox'
      />
      <FormControlLabel
        control={
          <ColoredCheckbox
            color='#029ce5'
            name='slack'
            onChange={(e) => handleChange(e)}
            checked={filter.slack}
          />
        }
        label='Slack'
      />
      <FormControlLabel
        control={
          <ColoredCheckbox
            color='#7887cb'
            name='tweet'
            onChange={(e) => handleChange(e)}
            checked={filter.tweet}
          />
        }
        label='Tweets'
      />
    </div>
  )
}

export default Filter
